import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Card, Dropdown, Form, Grid, Menu, Pagination, Segment, Table } from 'semantic-ui-react';
import PageContainer from '../../common/PageContainer';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { SERVER_URL } from '../../../constants';
import { useFormik } from 'formik';
import DigestStatusLabel from '../DigestStatusLabel';
import * as api from './../../../api/campaignApi';

export const DailyDigestSearch = ({ cities, digestFormats, addDailyDigest }) => {
  const [page, setPage] = useState(1);
  const [digests, setDigests] = useState([]);
  const initialValues = {
    siteId: 'All',
    subject: '',
    style: '',
    sendDate: '',
    pageSize: 50,
    offset: 0,
  };
  const [count, setCount] = useState(0);

  const search = async query => {
    console.log(query);
    const { digests, count } = await api.searchDigests(query);
    setCount(count);
    setDigests(digests);
  };

  const formik = useFormik({
    initialValues,
    onSubmit: search,
  });

  useEffect(() => {
    formik.handleSubmit();
  }, []);

  return (
    <PageContainer>
      <Menu borderless attached="top">
        <Menu.Item header>Daily Digest</Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item>
            <Dropdown text="New Email" icon="plus" labeled button className="button icon positive">
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => addDailyDigest('Daily Digest')}>Daily Digest</Dropdown.Item>
                <Dropdown.Item onClick={() => addDailyDigest('Hot Headlines')}>Hot Headlines</Dropdown.Item>
                <Dropdown.Item onClick={() => addDailyDigest('Dining Report')}>Dining Report</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <br />

      <Grid>
        <Grid.Column computer={13}>
          <Segment loading={formik.isSubmitting} basic padded={false} style={{ padding: 0 }}>
            <div style={{ minHeight: 500 }}>
              <Table size="small" compact="very" celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Subject line</Table.HeaderCell>
                    <Table.HeaderCell>Style</Table.HeaderCell>
                    <Table.HeaderCell>City</Table.HeaderCell>
                    <Table.HeaderCell>Send on</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                    <Table.HeaderCell collapsing></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {digests &&
                    digests?.map((digest, idx) => (
                      <Table.Row key={idx}>
                        <Table.Cell>
                          <Link to={'/daily-digest/create/' + digest.id}>{digest.subject}</Link>
                        </Table.Cell>
                        <Table.Cell>{digest.style}</Table.Cell>
                        <Table.Cell>{digest.site?.city}</Table.Cell>
                        <Table.Cell>
                          {digest.sendDateFormatted?.includes('Invalid') || !digest.sendDateFormatted?.includes(':')
                            ? ''
                            : digest.sendDateFormatted}
                        </Table.Cell>
                        <Table.Cell>
                          <DigestStatusLabel digest={digest} />
                        </Table.Cell>
                        <Table.Cell>
                          <Button
                            icon="binoculars"
                            as="a"
                            size="mini"
                            target="_blank"
                            href={`${SERVER_URL}/api/daily-digest/email/${digest.id}`}
                          />
                        </Table.Cell>
                      </Table.Row>
                    ))}
                </Table.Body>
              </Table>
            </div>
          </Segment>
          <br />
          <Grid centered>
            <Pagination
              style={{ marginBottom: 50 }}
              activePage={page}
              totalPages={Math.ceil(count / 10)}
              onPageChange={(e, { activePage }) => {
                console.log({ page, activePage });
                formik.setFieldValue('offset', 10 * (activePage - 1));
                formik.handleSubmit();
                setPage(activePage);
              }}
            />
          </Grid>
        </Grid.Column>
        <Grid.Column computer={3}>
          <Form onSubmit={formik.handleSubmit}>
            <div style={{ display: 'grid', alignItems: 'start' }}>
              <Card fluid>
                <Card.Content>
                  <Form.Field>
                    <label>Subject</label>
                    <Form.Input
                      icon="search"
                      name="subject"
                      value={formik.values.subject}
                      onChange={(e, { value }) => formik.setFieldValue('subject', value)}
                    />
                  </Form.Field>

                  <br />

                  <Form.Field>
                    <label>City</label>
                    <Form.Dropdown
                      name="siteId"
                      className="time-dropdown"
                      clearable
                      value={formik.values.siteId}
                      onChange={(e, { value }) => formik.setFieldValue('siteId', value)}
                      fluid
                      selection
                      options={cities}
                      // options={sites ? [{ key: ' ', value: '', text: 'All' }, ...sites.filter(s => s.key)] : []}
                    />
                  </Form.Field>

                  <br />

                  <Form.Field>
                    <label>Style</label>
                    <Form.Dropdown
                      value={formik.values.style}
                      fluid
                      name="style"
                      clearable
                      // placeholder="All"
                      selection
                      options={digestFormats}
                      onChange={(e, { value }) => formik.setFieldValue('style', value)}
                    />
                  </Form.Field>

                  <br />

                  <Button type="submit" content="Submit" positive fluid />
                  <br />

                  <Button
                    content="Clear"
                    onClick={() => {
                      formik.resetForm();
                      formik.handleSubmit();
                    }}
                    fluid
                  />
                </Card.Content>
              </Card>
            </div>
          </Form>
        </Grid.Column>
      </Grid>
    </PageContainer>
  );
};

const mapStateToProps = state => ({
  digests: selectors.getDigests(state),
  cities: selectors.admin.cultureMapCities(state),
  digestFormats: selectors.campaigns.digestFormats(state),
});

const mapDispatchToProps = dispatch => ({
  getDigests: bindActionCreators(actions.campaign.getDigests, dispatch),
  searchDigests: bindActionCreators(actions.campaign.searchDigests, dispatch),
  addDailyDigest: bindActionCreators(actions.campaign.addDailyDigest, dispatch),
  deleteDigestById: bindActionCreators(actions.campaign.deleteDigestById, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DailyDigestSearch);
